export interface CameraInfo {
  id: string;
  label: string;
  selected: boolean;
  hasAutofocus: boolean;
}


export interface ICameraService {
  detectDeviceType(): Promise<'mobile' | 'desktop' | 'tablet'>;
  enumerateDevices(): Promise<MediaDeviceInfo[]>;
  getAvailableCameras(): MediaDeviceInfo[];
  isMultipleCamerasAvailable(): boolean;
  getSelectedCameraId(): string | null;
  setSelectedCamera(cameraId: string): Promise<void>;
  getPreferredFacing(): 'environment' | 'user' | null;
  setupCamera(constraints?: MediaTrackConstraints): Promise<MediaStream>;
  switchCamera(cameraId: string): Promise<void>;
  isRearCamera(stream: MediaStream): boolean;
  getCameraInfo(): Promise<{
    availableCameras: CameraInfo[];
    selectedCameraId: string | null;
    deviceType: string;
    isMultipleCamerasAvailable: boolean;
    preferredFacing: 'environment' | 'user' | null;
  }>;
}